import { useMemo, useCallback } from 'react';

import type { PartBotResultJson } from '@frontend/api';
import { noop } from '@frontend/utils';

import type { ActionResolution } from 'modules/common/components/findings';

import { useCreateRuleActionData } from './CreateRuleActionDataContext';

type CreateRuleActionProps = {
  createRuleAction: () => void;
};

export const useCreateRuleAction = (
  partBotResult: PartBotResultJson | null,
): ActionResolution<CreateRuleActionProps> => {
  const { canCreateRule, createRuleAction, processPartBotResult } =
    useCreateRuleActionData();
  const ruleCreationPayload = useMemo(
    () =>
      canCreateRule && partBotResult
        ? processPartBotResult(partBotResult)
        : null,
    [processPartBotResult, partBotResult, canCreateRule],
  );
  const createRuleActionFn = useCallback(
    () => (ruleCreationPayload ? createRuleAction(ruleCreationPayload) : noop),
    [createRuleAction, ruleCreationPayload],
  );

  if (!ruleCreationPayload) {
    return { enabled: false, createRuleAction: createRuleActionFn };
  }

  return { enabled: true, createRuleAction: createRuleActionFn };
};
